import React from 'react';
import { Card, Form } from 'react-bootstrap';
import { CampaignFilterStatus } from '../../../../infrastructure/CampaignClient';
import type { CampaignFiltersProps } from './types';

const CampaignFilters: React.FC<CampaignFiltersProps> = ({ selectedStatus, onStatusChange, totalCampaigns }) => {
  const handleStatusChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onStatusChange(e.target.value as CampaignFilterStatus);
  };

  const getStatusDisplayText = (status: CampaignFilterStatus) => {
    switch (status) {
      case CampaignFilterStatus.ACTIVE:
        return 'Active';
      case CampaignFilterStatus.INACTIVE:
        return 'Inactive';
      case CampaignFilterStatus.DRAFT:
        return 'Draft';
      default:
        return 'All';
    }
  };

  return (
    <Card className="mb-4">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center m-2">
          <div className="d-flex align-items-center gap-3">
            <Form.Select value={selectedStatus} onChange={handleStatusChange} style={{ width: '200px' }}>
              <option value={CampaignFilterStatus.ALL}>All Campaigns</option>
              <option value={CampaignFilterStatus.ACTIVE}>Active Campaigns</option>
              <option value={CampaignFilterStatus.INACTIVE}>Inactive Campaigns</option>
              <option value={CampaignFilterStatus.DRAFT}>Draft Campaigns</option>
            </Form.Select>
            <span className="text-muted">Showing {getStatusDisplayText(selectedStatus)} campaigns</span>
          </div>
          <div className="text-muted">Total {totalCampaigns} campaigns</div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default CampaignFilters;
